export const PLAYER_CONSTANTS = {
  SCRUB_SECONDS: 10,
  FINE_SCRUB_SECONDS: 1,
  PREVIOUS_TRACK_THRESHOLD: 3,
  WAV_FADE_DURATION: 500
};
